import React, { useState } from "react";
import FormBtn from "./GetOffer/FormBtn";
import Pagefive from "./GetOffer/Pagefive";
import Pagefour from "./GetOffer/Pagefour";
import PageOne from "./GetOffer/PageOne";
import Pagethree from "./GetOffer/Pagethree";
import PageTwo from "./GetOffer/PageTwo";
import { SendOffer } from "../api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import useLocale from "../../helper/useLocale";
import { useTranslation } from "../../context/TranslationContext";
import BackButton from "../BackButton";

const GetOffer = ({ ssr, isAppWebView }) => {
  const { getOfferNextBtn, getOfferPrevBtn, getOfferFormError } =
    useTranslation();
  const localeData = useLocale();
  const [formdata, setformdata] = useState({
    startDate: null,
    endDate: null,
    priceType: 0,
    categoryType: 0,
    Categories: [],
    name: "",
    email: "",
    phone: "",
    adult: 0,
    child: 0,
    infant: 0,
  });
  const [validSteps, setvalidSteps] = useState({
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const maxPageLimit = 5;
  const minPageLimit = 1;

  const onPrevClick = () => {
    if (currentPage - 1 <= minPageLimit) setCurrentPage(minPageLimit);
    else setCurrentPage(currentPage - 1);
  };

  const onNextClick = () => {
    if (currentPage + 1 >= maxPageLimit) setCurrentPage(maxPageLimit);
    else setCurrentPage(currentPage + 1);
  };

  const handleSubmit = async function (setShow) {
    const a = { ...formdata };
    a.startDate = format(a.startDate, "yyyy-MM-dd", {
      locale: localeData,
    });
    a.endDate = format(a.endDate, "yyyy-MM-dd", {
      locale: localeData,
    });
    const response = await SendOffer(a);
    if (response.data.result) {
      setShow(true);
    } else toast.error(getOfferFormError);
  };

  const onModalClose = () => {
    setvalidSteps({
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
    });
    setformdata({
      startDate: null,
      endDate: null,
      priceType: 0,
      categoryType: 0,
      Categories: [],
      name: "",
      email: "",
      phone: "",
      adult: 0,
      child: 0,
      infant: 0,
    });
    setCurrentPage(1);
  };

  // const getOfferBgMap = {
  //   1: formdata.startDate && formdata.endDate,
  //   2: formdata.priceType > 0,
  //   3: formdata.categoryType > 0
  //   3: formdata.Categories.length > 0,
  //   4: formdata.name && formdata.email && formdata.phone && formdata.person > 0,
  //   5: true,
  // };

  return (
    <>
      <div className="flex lg:flex-nowrap flex-wrap lg:h-[calc(100vh-96px)] sm:min-h-[800px] relative">
        <div className="lg:w-1/2 w-full sm:block hidden">
          <div className="bg-getOffer sm:bg-get-offer bg-get-offer-pst bg lg:bg-[-252px]-bottom	 bg-contain bg-no-repeat lg:h-full sm:h-[400px] h-[190px]"></div>
        </div>
        <BackButton isAppWebView={isAppWebView} top="top-0" />
        <div className="lg:w-1/2 w-full xl:px-[80px] px-5 flex flex-col pt-1">
          <div className="flex justify-center lg:justify-end lg:mb-[50px] mb-8 lg:pt-[20px]">
            <span className="md:text-[31px] text-25 font-light text-black">
              {currentPage}/{maxPageLimit}
            </span>
          </div>
          {currentPage == 1 && (
            <PageOne
              formdata={formdata}
              setformdata={setformdata}
              validSteps={validSteps}
              setvalidSteps={setvalidSteps}
            />
          )}

          {currentPage == 2 && (
            <PageTwo
              formdata={formdata}
              setformdata={setformdata}
              validSteps={validSteps}
              setvalidSteps={setvalidSteps}
            />
          )}
          {currentPage == 3 && (
            <Pagethree
              formdata={formdata}
              setformdata={setformdata}
              validSteps={validSteps}
              setvalidSteps={setvalidSteps}
            />
          )}
          {currentPage == 4 && (
            <>
              <Pagefour
                formdata={formdata}
                setformdata={setformdata}
                validSteps={validSteps}
                setvalidSteps={setvalidSteps}
                data={ssr.result}
              />
            </>
          )}
          {currentPage == 5 && (
            <Pagefive
              formdata={formdata}
              setformdata={setformdata}
              validSteps={validSteps}
              setvalidSteps={setvalidSteps}
            />
          )}
          <div className="flex items-center justify-center lg:justify-end gap-x-[15px] mt-auto mb-16">
            {currentPage > 1 && (
              <button
                type="button"
                className="bg-getOffer3 md:py-[18px] py-3 md:px-[52px] px-7"
                onClick={onPrevClick}
              >
                <span className="text-white text-[16px] font-medium">
                  {getOfferPrevBtn}
                </span>
              </button>
            )}
            {currentPage !== maxPageLimit && (
              <button
                type="button"
                className={`${!validSteps[currentPage] ? "bg-getOffer2" : "bg-getOffer3"} text-[16px] text-white font-medium md:py-[18px] py-3 md:px-[52px] px-7 disabled:cursor-not-allowed`}
                onClick={onNextClick}
                disabled={!validSteps[currentPage]}
              >
                {getOfferNextBtn}
              </button>
            )}
            {currentPage === maxPageLimit && (
              <FormBtn
                disabled={Object.values(validSteps).every((e) => e == true)}
                handleSubmit={handleSubmit}
                onModalClose={onModalClose}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GetOffer;
